/* ============================================================
   GESTALTUNGS-BEGLEITER · Lieblingscap
   Reiner Beobachter ueber der bestehenden Produktkonfiguration -
   siehe ausfuehrliche Erklaerung im Liquid-Snippet. Liest nur
   bestehende DOM-Zustaende, schreibt nichts in Formularfelder.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('gestaltungs-begleiter');
  if (!root) return;

  /* Bewusst NICHT das <form action="/cart/add">-Element selbst als
     Suchbereich nehmen: Dawn haengt das Mengenfeld nur per form="..."
     -Attribut an, es liegt NICHT im DOM innerhalb des Formulars - und
     es gibt teils sogar ein zweites, leeres /cart/add-Formular auf
     der Seite. <product-info> umschliesst dagegen zuverlaessig
     Variantenauswahl, Menge, Umschalter, Personalisierungs-Karte UND
     den echten Kaufen-Button in einem einzigen, garantiert einzigen
     Element (live gegen die Vorschau-Seite geprueft, 22.09.2026). */
  var bereich = document.querySelector('product-info');
  if (!bereich) return;

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Produkttitel statt hart codiertem Namen - Komponente ist fuer
     jeden Produkttyp gedacht (Muetze/Tasche/Socke/Kappe), "Dein/e X"
     waere je nach grammatischem Geschlecht falsch. */
  var PRODUKT_TITEL = root.dataset.produktTitel || 'Deine Bestellung';

  var KARTEN_IDS = ['stickerei-karte', 'wunschlogo-karte', 'dtf-optionen'];
  var KARTEN_NAMEN = {
    'stickerei-karte': 'deinen Text',
    'wunschlogo-karte': 'dein Logo',
    'dtf-optionen': 'dein Design'
  };

  /* Pro Personalisierungs-Karte: wurde dort schon mindestens ein
     echtes Eingabe-Ereignis beobachtet? Verhindert, dass
     vorausgefuellte Standardwerte (z.B. "DEIN"/"TEXT" + erste
     Schriftart in der Stickerei-Karte) faelschlich als "vom Kunden
     erledigt" gezaehlt werden - rein UI-seitig, keine Kopie von
     Formulardaten. */
  var beruehrt = {};

  /* ---------- Helfer: bestehende DOM-Zustaende lesen ---------- */

  function ersteVariantenGruppe() {
    var vs = document.querySelector('variant-selects');
    return vs ? vs.querySelector('fieldset, .product-form__input--dropdown') : null;
  }

  function farbeSchritt() {
    var g = ersteVariantenGruppe();
    if (!g) return null;
    var gewaehlt = g.querySelector('input:checked') || g.querySelector('select option[selected]');
    if (!gewaehlt) return null;
    var legend = g.querySelector('legend');
    var label = 'Variante';
    if (legend) {
      var roh = legend.childNodes[0] ? legend.childNodes[0].textContent : legend.textContent;
      label = roh.replace(':', '').trim() || 'Variante';
    }
    return {
      id: 'farbe', label: label, wert: gewaehlt.value, ziel: g,
      status: 'complete', mikrocopy: 'Wähle deine ' + label.toLowerCase()
    };
  }

  function mengeFeld() {
    return bereich.querySelector('quantity-input input[type=number], input.quantity__input');
  }

  function mengeSchritt() {
    var inp = mengeFeld();
    if (!inp) return null;
    var wert = parseInt(inp.value, 10) || 0;
    var min = parseInt(inp.min || inp.dataset.min || '1', 10) || 1;
    var ok = wert >= min;
    return {
      id: 'menge', label: 'Menge', wert: wert + ' Stück',
      ziel: inp.closest('.product-form__input') || inp,
      status: ok ? 'complete' : 'error',
      mikrocopy: ok ? '' : 'Mindestens ' + min + ' Stück'
    };
  }

  /* Findet die Kette aktiver .va-wrapper-Umschalter (z.B. erst
     Veredelungsart, danach - falls vorhanden - verschachtelt
     Wunschtext/Wunschlogo) ausgehend vom uebergebenen Suchbereich.
     Generisch: kennt keine Produkt-Namen, liest Label/Werte direkt
     aus dem bestehenden Markup (.va-label, .va-seg input). */
  function aktiveUmschalter(startBereich) {
    var liste = [];
    var bereich = startBereich;
    var i = 0;
    while (true) {
      var wrapper = bereich.querySelector('[data-va-wrapper]');
      if (!wrapper) break;
      var radios = wrapper.querySelectorAll(':scope > .va-block .va-seg input[type=radio]');
      if (!radios.length) break;
      var checked = wrapper.querySelector(':scope > .va-block .va-seg input[type=radio]:checked') || radios[0];
      var panelName = checked.dataset.panel;
      var panel = wrapper.querySelector(':scope > .va-panel[data-va-panel="' + panelName + '"]');
      var labelEl = wrapper.querySelector(':scope > .va-block .va-label');
      var label = labelEl ? labelEl.textContent.replace('*', '').trim() : 'Auswahl';
      liste.push({
        id: 'wahl-' + i, label: label, wert: checked.value, ziel: wrapper,
        status: 'complete', mikrocopy: label + ' wählen'
      });
      i++;
      if (!panel) break;
      bereich = panel;
    }
    return { schritte: liste, bereich: bereich };
  }

  function findePersonalisierungsKarte(bereich) {
    for (var i = 0; i < KARTEN_IDS.length; i++) {
      var el = bereich.querySelector('#' + KARTEN_IDS[i]);
      if (el) return el;
    }
    return null;
  }

  function personalisierungSchritt(bereich) {
    var karte = findePersonalisierungsKarte(bereich);
    if (!karte) return null;

    var blockerListe = karte.querySelector('.va-blocker-liste');
    var probleme = blockerListe
      ? Array.prototype.map.call(blockerListe.children, function (li) { return li.textContent; })
      : [];
    var hatBeruehrt = !!beruehrt[karte.id];

    /* Sonderfall Wunschlogo: komplexe/mehrfarbige Logos brauchen ein
       Angebot statt Direktkauf (wunschlogo-karte.js, braucchtAnfrage()).
       Blocker-Liste bleibt dabei leer, deshalb eigener Zusatz-Check -
       sonst wuerde der Begleiter faelschlich "fertig" zeigen. */
    var anfrageEl = karte.querySelector('[id$="-anfrage"]');
    var brauchtAnfrage = !!(anfrageEl && !anfrageEl.hidden);

    var status, mikrocopy;
    var name = KARTEN_NAMEN[karte.id] || 'deine Gestaltung';
    if (brauchtAnfrage) {
      status = 'anfrage';
      mikrocopy = 'Individuelles Angebot nötig – wir melden uns schnell';
    } else if (probleme.length === 0 && hatBeruehrt) {
      status = 'complete';
      mikrocopy = '';
    } else if (hatBeruehrt) {
      status = 'error';
      mikrocopy = probleme[0] || '';
    } else {
      status = 'open';
      mikrocopy = 'Jetzt ' + name + ' gestalten';
    }

    return {
      id: 'personalisierung', label: 'Personalisierung', wert: null, ziel: karte,
      status: status, mikrocopy: mikrocopy, karteId: karte.id
    };
  }

  function schritteErmitteln() {
    var liste = [];
    var f = farbeSchritt();
    if (f) liste.push(f);
    var m = mengeSchritt();
    if (m) liste.push(m);

    var umschalterErgebnis = aktiveUmschalter(bereich);
    umschalterErgebnis.schritte.forEach(function (s) { liste.push(s); });

    var p = personalisierungSchritt(umschalterErgebnis.bereich);
    if (p) liste.push(p);

    return liste;
  }

  /* ---------- Fortschritt ---------- */

  function fortschritt(schritte) {
    if (!schritte.length) return 0;
    var letzter = schritte[schritte.length - 1];
    var vorherige = schritte.slice(0, -1);
    var anteil = vorherige.length ? 60 / vorherige.length : 0;
    var summe = 0;
    vorherige.forEach(function (s) { if (s.status === 'complete') summe += anteil; });
    if (letzter.status === 'complete') summe += 40;
    else if (letzter.status === 'error' || letzter.status === 'anfrage') summe += 20;
    return Math.round(Math.min(100, summe));
  }

  function aktivenSchrittFinden(schritte) {
    for (var i = 0; i < schritte.length; i++) {
      if (schritte[i].status !== 'complete') return schritte[i];
    }
    return null;
  }

  /* ---------- Ziel-Highlight beim Klick ---------- */

  function zuSchrittSpringen(schritt) {
    var ziel = schritt.ziel;
    if (!ziel) return;
    ziel.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'center' });
    ziel.classList.add('gb-highlight');
    window.setTimeout(function () { ziel.classList.remove('gb-highlight'); }, 1600);
    if (!ziel.hasAttribute('tabindex')) ziel.setAttribute('tabindex', '-1');
    ziel.focus({ preventScroll: true });
  }

  /* ---------- Rendern ---------- */

  function icon(status) {
    if (status === 'complete') return '✓';
    if (status === 'anfrage') return '!';
    return '○';
  }

  /* Schritte NACH dem gerade aktiven gelten als LOCKED, unabhaengig
     von ihrem eigenen rohen Status (z.B. koennte "Personalisierung"
     technisch schon "open" sein, obwohl die Menge noch nicht passt -
     fuer die Anzeige zaehlt aber erst, was der Kunde jetzt wirklich
     als Naechstes tun soll). */
  function mitSperrenAnwenden(schritte, aktivIndex) {
    return schritte.map(function (s, i) {
      if (i > aktivIndex) return { id: s.id, label: s.label, wert: s.wert, status: 'locked', ziel: s.ziel };
      return s;
    });
  }

  function schrittZeile(schritt, istAktiv, klickbar) {
    var klasse = 'gb-zeile gb-zeile--' + schritt.status + (istAktiv ? ' gb-zeile--aktiv' : '');
    var inhalt =
      '<span class="gb-icon" aria-hidden="true">' + icon(schritt.status) + '</span>' +
      '<span class="gb-zeile-text">' +
        '<span class="gb-zeile-label">' + schritt.label + '</span>' +
        (schritt.wert ? '<span class="gb-zeile-wert">' + schritt.wert + '</span>' : '') +
      '</span>';
    if (klickbar) {
      return '<button type="button" class="' + klasse + '" data-gb-ziel="' + schritt.id + '">' + inhalt + '</button>';
    }
    return '<div class="' + klasse + '">' + inhalt + '</div>';
  }

  function render() {
    var schritte = schritteErmitteln();
    if (!schritte.length) { root.hidden = true; return; }

    var prozent = fortschritt(schritte);
    var aktiv = aktivenSchrittFinden(schritte);
    var fertig = !aktiv;

    var submitBtn = bereich.querySelector('[type=submit], .product-form__submit');
    /* Letzter Realitaets-Check: der Kaufen-Button ist die eigentliche
       Wahrheit. Weicht unsere Ableitung ab (z.B. unbekannter Sonderfall),
       gewinnt der Button - der Begleiter behauptet nie "fertig", wenn
       tatsaechlich noch gesperrt ist. */
    if (fertig && submitBtn && submitBtn.disabled) fertig = false;

    var aktivIndex = aktiv ? schritte.indexOf(aktiv) : schritte.length - 1;
    var anzeigeSchritte = mitSperrenAnwenden(schritte, aktivIndex);

    var zeilenHtml = anzeigeSchritte.map(function (s, i) {
      var istAktiv = !fertig && i === aktivIndex;
      var klickbar = s.status !== 'locked';
      return schrittZeile(s, istAktiv, klickbar);
    }).join('');

    var fertigZeile =
      '<div class="gb-zeile gb-zeile--' + (fertig ? 'complete' : 'locked') + '">' +
        '<span class="gb-icon" aria-hidden="true">' + (fertig ? '✓' : '○') + '</span>' +
        '<span class="gb-zeile-text"><span class="gb-zeile-label">Fertig</span></span>' +
      '</div>';

    var mikrocopy = fertig
      ? 'Alles fertig.'
      : (aktiv && aktiv.mikrocopy ? aktiv.mikrocopy : 'Weiter geht’s');

    var html =
      '<div class="gb-karte">' +
        '<div class="gb-kopf">' +
          '<p class="gb-titel">' + PRODUKT_TITEL + '</p>' +
          '<button type="button" class="gb-minimieren" aria-label="Begleiter minimieren">–</button>' +
        '</div>' +
        '<div class="gb-bar"><div class="gb-bar-fuellung" style="width:' + prozent + '%"></div></div>' +
        '<p class="gb-prozent">' + prozent + ' %</p>' +
        '<div class="gb-liste">' + zeilenHtml + fertigZeile + '</div>' +
        '<p class="gb-mikrocopy' + (fertig ? ' gb-mikrocopy--fertig' : '') + '">' + mikrocopy + '</p>' +
      '</div>' +
      /* Minimiert-Icon: nur auf Desktop sichtbar (CSS), rechts am
         Rand, zeigt den Fortschritt weiter als Ring, auch wenn die
         Karte zugeklappt ist. */
      '<button type="button" class="gb-icon-knopf" aria-label="Begleiter öffnen (' + prozent + '% fertig)">' +
        '<span class="gb-icon-knopf-ring" style="--gb-prozent:' + prozent + '"><span>' + prozent + '%</span></span>' +
      '</button>' +
      '<button type="button" class="gb-mobil" aria-expanded="false">' +
        '<span class="gb-mobil-ring" style="--gb-prozent:' + prozent + '"><span>' + prozent + '%</span></span>' +
        '<span class="gb-mobil-text">' +
          '<strong>' + PRODUKT_TITEL + '</strong>' +
          '<span>' + (fertig ? 'Bereit für den Warenkorb' : mikrocopy) + '</span>' +
        '</span>' +
        '<span class="gb-mobil-pfeil" aria-hidden="true">▲</span>' +
      '</button>';

    root.innerHTML = html;
    root.hidden = false;
    root.classList.toggle('gb--fertig', fertig);

    if (fertig && submitBtn) submitBtn.classList.add('gb-hervorgehoben-ziel');
    else if (submitBtn) submitBtn.classList.remove('gb-hervorgehoben-ziel');

    /* Klick-Handler frisch verdrahten (innerHTML wurde ersetzt). */
    root.querySelectorAll('[data-gb-ziel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var s = schritte.filter(function (x) { return x.id === btn.dataset.gbZiel; })[0];
        if (s) zuSchrittSpringen(s);
      });
    });

    var minimierenBtn = root.querySelector('.gb-minimieren');
    if (minimierenBtn) {
      minimierenBtn.addEventListener('click', function () { root.classList.add('gb--minimiert'); });
    }
    var iconBtn = root.querySelector('.gb-icon-knopf');
    if (iconBtn) {
      iconBtn.addEventListener('click', function () { root.classList.remove('gb--minimiert'); });
    }

    var mobilBtn = root.querySelector('.gb-mobil');
    if (mobilBtn) {
      mobilBtn.addEventListener('click', function () {
        var offen = root.classList.toggle('gb--offen');
        mobilBtn.setAttribute('aria-expanded', String(offen));
      });
    }
  }

  var renderGeplant = false;
  function renderAnfordern() {
    if (renderGeplant) return;
    renderGeplant = true;
    window.requestAnimationFrame(function () { renderGeplant = false; render(); });
  }

  /* ---------- Ereignisse (keine Polling-Schleife, nur bestehende
     native Events, die die Personalisierungs-Karten selbst schon
     nutzen) ----------
     WICHTIG: Capture-Phase (dritter Parameter "true"), nicht Bubble.
     stickerei-karte.js/wunschlogo-karte.js bauen ihr eigenes DOM bei
     JEDER Eingabe komplett neu (innerHTML = '' + Neuaufbau, siehe
     zeichneBloecke()). In der Bubble-Phase ist das urspruengliche
     Zielelement zu diesem Zeitpunkt schon aus dem DOM entfernt,
     e.target.closest(...) findet dann keine Karte mehr. Die
     Capture-Phase laeuft VOR dem eigenen Handler der Karte, also
     noch am unveraenderten DOM - live auf der Vorschau-Seite so
     verifiziert (22.09.2026). */

  var KARTEN_SELEKTOR = KARTEN_IDS.map(function (id) { return '#' + id; }).join(',');

  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects')) renderAnfordern();
    var karte = e.target.closest(KARTEN_SELEKTOR);
    if (karte) { beruehrt[karte.id] = true; renderAnfordern(); }
    if (e.target.closest('[data-va-wrapper]')) renderAnfordern();
  }, true);
  document.addEventListener('input', function (e) {
    var karte = e.target.closest(KARTEN_SELEKTOR);
    if (karte) { beruehrt[karte.id] = true; renderAnfordern(); }
  }, true);
  bereich.addEventListener('click', function (e) {
    var karte = e.target.closest(KARTEN_SELEKTOR);
    if (karte) beruehrt[karte.id] = true;
    renderAnfordern();
  }, true);
  var mengeEl = mengeFeld();
  if (mengeEl) mengeEl.addEventListener('input', renderAnfordern);

  render();
})();
